var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQueue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-2",
    cx: 416.38,
    cy: 444.01,
    rx: 48.76,
    ry: 28.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 104.78,
    cy: 267.41,
    rx: 46.37,
    ry: 26.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 177.95,
    cy: 310.02,
    rx: 46.37,
    ry: 26.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 252.05,
    cy: 353.33,
    rx: 46.37,
    ry: 26.77,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-2",
    cx: 327.39,
    cy: 396.19,
    rx: 46.37,
    ry: 26.77,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375.23,57.59l8.93,5.16c0-.4-.07-.8-.07-1.18V59c0-4.61,3.23-6.48,7.22-4.18A14,14,0,0,1,395.62,59c.65-5.8,5.2-8,10.72-4.77,6,3.45,10.81,11.83,10.81,18.72v3.88a10.31,10.31,0,0,1-.91,4.49l7.42,4.28a8.88,8.88,0,0,1,4,6.94c0,2.56-1.8,3.6-4,2.32l-48.43-28a8.82,8.82,0,0,1-4-6.94C371.22,57.35,373,56.31,375.23,57.59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337,83.63l6.74,3.9c0-.31-.05-.6-.05-.9V84.68c0-3.48,2.44-4.89,5.45-3.15a10.48,10.48,0,0,1,3.25,3.13c.49-4.38,3.92-6,8.09-3.6,4.51,2.6,8.16,8.93,8.16,14.13v2.92a7.71,7.71,0,0,1-.69,3.39l5.6,3.24a6.68,6.68,0,0,1,3,5.23c0,1.93-1.36,2.72-3,1.75L337,90.62a6.7,6.7,0,0,1-3-5.24C334,83.45,335.31,82.67,337,83.63Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M434.05,430.62c2.42-2.86,8.94-5.45,17.1-6s16.43-1.54,15.27-6.4c-1.25-5.24-8.57-6.54-16.2-4.63-8.33,2.08-15.3,9.23-16.13,14.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.16,428.88a.58.58,0,0,0,.56-.25C442.58,417,456.91,417,461.24,418.3a.57.57,0,0,0,.72-.38.58.58,0,0,0-.38-.72C457,415.81,442,415.79,433.76,428a.59.59,0,0,0,.16.8A.64.64,0,0,0,434.16,428.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.05,430.62s5.95-14.44,16.7-21.11c3.19-2,6.66-4.54,9.08-6.3,5.19-3.78,4-8.88-2.33-9.71-9.4-1.22-17.4,5.69-21.86,15.59S434.05,430.62,434.05,430.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.14,423.75a.56.56,0,0,0,.63-.42C439,405.64,454,398.6,457.86,398.18a.56.56,0,0,0,.5-.62.56.56,0,0,0-.62-.49c-4.68.5-19.71,7.88-24.06,26a.56.56,0,0,0,.41.68Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.13,258c4.79-1.13,7.9,2.91,11,10.44s8.59,25.87,9.87,30.9c.58,2.25-13.69,22.42-13.08,22.12.19-.09-5.57-9.72-5.57-9.72l7-13.4-5-12.18Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.94,428c.65.25.81,1.48.91,3.94.07,1.87.47,5.12-1.71,5.77s-5.37.31-6.77-1.44c-1.75-2.19-2.93-4.12-5.41-6.79-2.16-2.32-4.5-4.49-5.37-7.74-.79-2.94-.13-4.21,1.87-5.07,2.76-1.17,7.09,2.67,9.25,3.27C438.57,420.41,443.29,427.7,443.94,428Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.94,424v4.72a7.39,7.39,0,0,1-7.64.21c-.13-.29-.51-4.93-.51-4.93Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.46,444s.86,2.62,1.33,4.92c.37,1.83.9,4.88.26,6.25s-3.13,2.26-7,2.23c-2.5,0-6.41,1.69-9.08,3.18s-5.76,1.55-8.68,1.2c-3.44-.4-7-2.4-7.56-3.82s.16-2.11,8.27-5.57c.07,0,8.55-3.86,12.47-8.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.46,440.74s0,2.24,0,3.52-1.51,3.19-5.42,3.05c-2.75-.1-4.68-.84-4.57-3.1v-3.27Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,389.09c-.25-10-2.3-14.34-2.3-14.34s.76-12.31,2.42-27.37c2.52-22.95,1.36-27.39-3.17-37.72,0,0-38.62-3.91-39.79,12.14-1.47,20-1.65,55.43-1.11,62.49s.52,5.75,2.23,20c1.36,11.3,4.16,36.61,4.16,36.61a10.62,10.62,0,0,0,10-.2s3.15-32.14,2.82-40.28c-.4-9.95-1-12.48-1-12.48s4.52-29.39,5.22-34.58c0,0,.63,9.28,1.16,16.34s.48,9.94,2,24.54c1.17,11.45,4,31,4,31a9.53,9.53,0,0,0,8.43-.62S449.24,397.15,449,389.09Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.35 252.8 419.16 267.72 432.28 266.54 430.78 249.97 417.35 252.8",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.08,265.21c-1.44-3.92-4.75-8-9.79-7.1-1.32.25-2.47.44-3.71.69-.11,3.43-6.59,5.21-13.05,3.13-1.94.56-3.72,1.12-5.33,1.7-4.62,1.65-6.47,9.32-6.58,22.15s-1.46,44.84-1.46,44.84l5.4,1.7,2.52-9.37,1,11.22a40.22,40.22,0,0,0,18.64-.09c13.88-3,18.19-10.52,18.19-10.52A87.44,87.44,0,0,0,439.88,298C446.84,279.53,447.22,271,445.08,265.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.6,233.84a11.5,11.5,0,0,1,1-11.09c4.4-6.91,12.89-8.09,23-5.4a17.85,17.85,0,0,1,12.59,16.21c.48,7.38-20.1,12.82-19.63,17.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.16,236.65s-2.8,4.47-2.4,4.93a7,7,0,0,0,2.25.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.67,222.46c-2.79,1.54-7.6,4.38-8.58,14.83-1,10.73,1.48,14.39,3,15.75,1,.92,6.1,1.13,8.72.23,3.29-1.12,10.38-4.86,13.6-10.47,3.78-6.61,4.37-15.29-.3-18.56C425.53,219.64,418,221.16,415.67,222.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.66,223.73a41.2,41.2,0,0,0-3,12.32,11.29,11.29,0,0,1-3.78-.61s-.05-4.5,1.16-7.06a18.18,18.18,0,0,0-2.2,6.68,7,7,0,0,1-3.58-1.34c-1-4.81,2-14.73,10.55-16.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.85,222.93s-2.2,9.83.92,15.92c0,0,1.62-3.86,4.93-2.85s3.14,5.41.61,7.73a4.92,4.92,0,0,1-5.08,1.22,22.08,22.08,0,0,0,4.9,7.41s9.78,4.36,18.25-5.2c7.69-8.67,6.26-23.8-5.51-27.36S414.85,222.93,414.85,222.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.41,245.08c2.32,2.46,1.88,6.64-1,9.34s-7.06,2.9-9.38.45-1.88-6.65,1-9.35S445.08,242.62,447.41,245.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.39,240.78a2.31,2.31,0,0,0-1.49,2.9l4.39-1.41A2.31,2.31,0,0,0,443.39,240.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,287.26c-1.91-2.17-2.22-7-4.76-10.28s-2.08-6.64-3.67-5.16-.4,6.91-.4,6.91-2.95,5.48-3.21,8.28,7.18,9.85,7.18,9.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.57,278.35s-3,4.2-16.54-1.29c-3.74-1.51-1.22,6.53,3.37,9.86,4.24,3.08,9.55,4,13.8,6.91C372.21,293.42,371.57,278.35,371.57,278.35Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.35,263.23c-3.86,1.34-7.23,2.9-10.83,9.66-4.63,8.7-13,25.72-13,25.72L380,287.26s-1.53-2.15-4.37,2.54-1.58,6-1.58,6,12.2,16.33,14.43,18.41,5.92.46,8.32-2.8,14.81-25.75,14.81-25.75S419.8,271.45,414.35,263.23Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.53,353.4l.73-7.8A29.49,29.49,0,0,0,441,341.14s-2.51,4-9.39,5.85l-1.56,7.6-.4,15.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.45,294.64s4.85-8.49,5.16-9l-5.55,21.53Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M348.9,243.71c1.42,1.49,4.79,2.64,26.61,4.23a20.94,20.94,0,0,0,9.37-1.23,15.83,15.83,0,0,0,7.26-5.79,5.82,5.82,0,0,0,.92-1.91,2.66,2.66,0,0,0-.29-2,3,3,0,0,0-1.74-1.12,6.34,6.34,0,0,0-4.09.44c-2,.78-3.56,1.05-3.41.64s1.37-.78,2.62-2.19,1.57-3.39.76-4-.67-.48-2.11.72-3.1,1.81-5,3.65a11.18,11.18,0,0,1-4.42,3.07c-2.19.87-4.26.61-10.34-.36-5.25-.84-7.27-1.14-9.79-2.54-2.71-4.12-9.25-21.53-12.09-26.3-3-5.05-9.1-5.2-9.1-5.2a58.84,58.84,0,0,0,3.08,18.28C339.24,228,347.49,242.24,348.9,243.71Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.41,203.25a11.15,11.15,0,0,1,7.31,1.29c3.31,2.08,5.47,5.93,7.56,10.75,2.56,5.86,5.64,13.7,5.64,13.7a17.87,17.87,0,0,1-11,5l-9.85-16.37Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 309.12,
    y: 376.48,
    width: 8.5,
    height: 14.55,
    transform: "translate(626.74 767.51) rotate(180)",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.64 380.14 341.14 380.43 341.56 365.04 332.64 364.74 332.64 380.14",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.5,267.83c0,8.12,1.44,55.33,1.44,55.33-.2,2.33-2.45,6.48-2.62,14.9-.26,12.2,4.44,45.69,4.44,45.69a11.18,11.18,0,0,0,9.46.19s3.86-45.41,5.38-57.48c1.33-10.54,3.58-39.17,3.58-39.17l4,34.4a48.36,48.36,0,0,0-1.06,13.51c.4,5.59,2,40.17,2,40.17a11.59,11.59,0,0,0,9.82.75s6-49.3,6.09-54.43c.11-5.84-2.22-65.48-2.22-65.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.09,208.12a7.85,7.85,0,0,0-4.1,4.26,20,20,0,0,0-1.24,7.35v16.65l-.25,31.45c12.2,6.43,27.71,6.86,40.73-2.65,0,0-.73-40.47-.73-47.09,0-.3,0-.6,0-.91-.48-9.46-9.79-16-19-13.59l-7.7,2-7.73,2.55Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 332.91,
    cy: 177.15,
    r: 11.68,
    transform: "translate(-27.75 287.29) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.72,185.45s1.89,8.89,2.65,10.36a4,4,0,0,0,2.33,1.87l-.13-6.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.09,172.71a4.36,4.36,0,0,0-3.62,1.28c-1.56,1.59-.69,6.58,1.25,11.46l3.56.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.35,185.86c-.71.43-1.73-.94-2.61-1.87s-3.76-2.18-5.2.85,1.27,7.15,3.53,7.86c3.91,1.23,4.5-1.27,4.5-1.27l.28,14.51h0c4.86,6.23,18.33,5.7,12.72-.8v-4.29a24.4,24.4,0,0,0,5.26.27c2.87-.44,4.68-2.71,5.55-5.82,1.4-5,1.93-9,.75-18.84-1.31-10.76-13.82-10.88-20.58-6.62S317.35,185.86,317.35,185.86Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.35,187.07c-.36,0-1.72-2.27-2.61-3.08-1.24-1.12.35-11.28.35-11.28a4.82,4.82,0,0,1,1.19-5.14c1.69-1.86,3.53-3,8.4-3.29a97,97,0,0,1,10,.47c4.81.32,6.58-.86,9.35-1.64,2.11-.59,2.35,7-3,9.57,0,0-1.74,1.12-6.31,1.68a68.6,68.6,0,0,1-12.68-.24c-1.32-.18-1.6,1.1-2.32,4.61C319.08,181.82,318.56,187,317.35,187.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,173.5l-4.32-2.32a2.38,2.38,0,0,1,3.27-1.08A2.58,2.58,0,0,1,315.1,173.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.56,200.85s-6.41-1.29-8.65-2.48a7.37,7.37,0,0,1-3.1-3.07,10.08,10.08,0,0,0,1.76,3.62c1.64,2.09,10,3.64,10,3.64Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.24,184.26a1.28,1.28,0,1,1-1.28-1.34A1.3,1.3,0,0,1,330.24,184.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.88,179.41l-2.75,1.52a1.66,1.66,0,0,1,.64-2.19A1.53,1.53,0,0,1,328.88,179.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,193.13l2.93,1.11a1.54,1.54,0,0,1-2,1A1.65,1.65,0,0,1,330,193.13Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.33,180.48l-2.51-1.93a1.51,1.51,0,0,1,2.18-.33A1.66,1.66,0,0,1,341.33,180.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56,183.89a1.29,1.29,0,1,1-2.57,0,1.29,1.29,0,0,1,1.28-1.33A1.31,1.31,0,0,1,340.56,183.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.01 182.68 334.43 190.4 338.47 189.03 334.01 182.68",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,386.83v-1.21c.81.35,2.7,7.56,6.08,10.64,2.68,2.44,6.34,5.27,7.27,8s-5.1,4.4-7.6,4c-2.91-.52-8-2.57-9.22-4.47s-1.86-4.7-2.89-6.09-3.4-2.95-4-4.56c-.3-.88.06-2.82.49-4.46s.82-3.15,1.33-3v.92a6.68,6.68,0,0,0,4.25,1.44C314.61,388,317.63,387.78,317.62,386.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.23,377.81c.44,0,.8.64,1.77,1.69a18.47,18.47,0,0,0,5,3.6c3.18,1.59,9.37,4,12.17,5.31,1.75.79,1.67,2.9-.14,4.1s-6.17,2.07-11.42.9c-2.85-.64-6.57-3.28-8.92-3.14s-6.76.11-8.5-1.09-1-3.75-.55-5.95c.54-2.39,1.21-6.13,2-6v.83c1,1.54,6.3,2.17,8.54,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.18,287.29A31.38,31.38,0,0,0,339,280.5s-2.28,4.28-9.08,8.26l.91,30Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M291.66,250.37c5.45-31.9,11-41.6,20.17-41.93,2.82,3.05,2.56,12.71-1.36,18.75,0,0-8.4,20.27-9.55,27.39-1,6.25-2.11,14.1-1.76,19.42a3.88,3.88,0,0,0,1.17,2.47c1.81,1.78,1.89,3.27,3.1,5.27.95,1.57,1.93,2.12,1.68,2.5a2.09,2.09,0,0,1-2.81.35,10.44,10.44,0,0,1-2.23-1.95,21.22,21.22,0,0,0,2,5.62c2.14,4.24,1.79,6.48-4.16,5.23-3.72-.79-6.18-3.74-7.17-12.54a69.3,69.3,0,0,1-.58-9.77C290.5,262.76,290.8,255.39,291.66,250.37Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.06,207.14c-2.78.51-9.91.76-13.57,8.13-2.4,4.85-4.82,12.45-7.41,21.55,0,0,5.35,5.54,13.24,4.75l4.42-12.74C314.93,223.41,316,211.22,314.06,207.14Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.44,205c-7.77-31.29-16.65-38.55-8.35-42.77,8.53-.83,12.93,4.21,14.41,13.19.73,4.4,2.31,22.44,4.29,29.51,1.75,6.21,4.09,13.95,6.69,18.7a3.9,3.9,0,0,0,2.14,1.79c2.43.87,3.15,2.22,5.12,3.55,1.55,1,2.69,1.13,2.62,1.58a2.11,2.11,0,0,1-2.44,1.53,11.05,11.05,0,0,1-2.9-.84,21.57,21.57,0,0,0,4.22,4.34c3.8,3,4.43,5.24-1.6,6.62-3.78.86-7.31-.81-12-8.52a69.61,69.61,0,0,1-4.72-8.79C267.66,217,264.69,210.08,263.44,205Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.63,344.55v-1.21c.48,1.42,2.7,7.55,6.07,10.62,2.68,2.45,6.33,5.27,7.26,8s-5.08,3.78-7.59,3.34c-2.9-.51-6.66-2.16-8.71-4.68-1.44-1.77-2.36-3.86-3.39-5.25s-3.39-2.95-4-4.56c-.3-.88.06-2.82.49-4.45s.82-3.16,1.33-3v.92a6.78,6.78,0,0,0,4.25,1.44C233.63,345.74,236.64,345.5,236.63,344.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.12,356.11c-.83-.74-1.66-1.46-2.42-2.16-2.35-2.14-4.15-5.78-5.18-8.27a11.6,11.6,0,0,1-.89-4.46v-4.84h-8.49v7.87h0v.21l0,0c.41,1.76,4.31,6.45,6.52,9.51,1.48,2.05,4.3,4.66,7.67,5.11C245.57,359.54,247.2,358.53,245.12,356.11Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,336.18V335c.47,1.42,2.7,7.55,6.06,10.62,2.68,2.45,6.34,5.27,7.26,8s-5.08,3.78-7.58,3.34c-2.91-.51-6.67-2.16-8.72-4.68-1.44-1.77-2.35-3.86-3.38-5.25s-3.4-2.95-3.95-4.56c-.31-.88.05-2.82.48-4.45s.82-3.15,1.34-3v.92a6.74,6.74,0,0,0,4.24,1.44C266.74,337.37,269.76,337.13,269.75,336.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,347.74c-.83-.74-1.67-1.46-2.43-2.15-2.35-2.15-4.14-5.79-5.17-8.28a11.56,11.56,0,0,1-.89-4.46V328h-8.49v7.87h0v.21l0,0c.41,1.76,4.3,6.45,6.52,9.51,1.48,2.05,4.3,4.66,7.67,5.11C278.68,351.17,280.31,350.16,278.24,347.74Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.83,212.61c-6.58,14.37.24,65,.24,65-.2,2.33-2.87,6.93-3.86,17.19-1.18,12.13,1.84,42.6,1.84,42.6a9.19,9.19,0,0,0,8.58.34s8.09-45.88,9.61-57.94c1.33-10.53,3.88-33.68,3.88-33.68l7.24,33.62a62.29,62.29,0,0,0-2.29,10.39c-.69,7.09,6.19,40.13,6.19,40.13s2.93,1.07,8.49.25c0,0,2.43-43.83,3.07-52.38,1.07-14.35-2.74-59.14-5.37-67.64Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12,246.13l2.14-13.35s9-1.87,13.14-5.73c0,0-4.3,5.36-10.69,7.11l-2.4,10.28,4.19,31.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.44,162.66h0c-8.44.58-9,4.66-11.14,9.12a14.4,14.4,0,0,0-.4,10.87l5.88,17a74.35,74.35,0,0,0-5.95,13c14.76,8.23,33.18,3.9,37.62-2.11.19-1.27-.95-11.24-1.66-17.75,2.6-6.52,3.29-10.65,2.19-15-2-8-9.93-15.79-13.43-15.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.47,154.91l-6.22,0a15.69,15.69,0,0,1-15.76-15.63h0a18.81,18.81,0,0,1,18.72-18.89h0a18.81,18.81,0,0,1,18.89,18.73h0A15.69,15.69,0,0,1,251.47,154.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.34,116c2.69,4-.16,6.66-4.12,9.35s-7.51,4.33-10.2.38-1.21-8.37,2.75-11S240.66,112.05,243.34,116Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.66,128.24l-4,2.94a2.41,2.41,0,0,1,.43-3.45A2.58,2.58,0,0,1,233.66,128.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.84,128.8c2,1.16,4.47,6.15,4.27,16.63-.17,8.88-3,11.08-4.48,11.72s-4.23.27-6.94-.17l.16,5.39s4.56,3.74,4.34,6.18-6.33,3.57-9.85,1.2A40.91,40.91,0,0,1,241,164.3a.55.55,0,0,1-.14-.37V150.49s-1.59,1.56-4.3-.8c-2.24-1.94-3-5.23-1.28-7a3.88,3.88,0,0,1,6.19,1.21s4.33.14,10.07-3.05A16.16,16.16,0,0,0,259.84,128.8Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.19,143.24a1.12,1.12,0,1,1-1.18-1.1A1.15,1.15,0,0,1,254.19,143.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.52,150.76l2.6.82a1.35,1.35,0,0,1-1.69.94A1.44,1.44,0,0,1,254.52,150.76Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.33,139.77l-2.27-1.55a1.32,1.32,0,0,1,1.88-.4A1.45,1.45,0,0,1,263.33,139.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.82,142.4a1.12,1.12,0,1,1-1.18-1.11A1.15,1.15,0,0,1,262.82,142.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.79 141.22 257.76 148.5 261.29 147.39 257.79 141.22",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.69,157c-2.86-.37-8.74-2-9.66-4.35a6,6,0,0,0,2.07,3c1.76,1.49,7.64,3.18,7.64,3.18Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.21,214.2a8.91,8.91,0,0,1-6.64-10.86,4.42,4.42,0,0,1,.15-.47,2.9,2.9,0,0,1,3-2h0a8.5,8.5,0,0,1-3.26-5.69l-2.22-10.47a12.48,12.48,0,0,1,.45-5.17l-5.93-6.86-1.09.76a14.75,14.75,0,0,0,.24,9.19l5.88,17a68.32,68.32,0,0,0-5.95,13,38.11,38.11,0,0,0,31.53,2.08A42.83,42.83,0,0,1,245.21,214.2Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M242,239.3,220.54,227s-10.44,14.34-3.33,18.39,14.16,8.18,21.24,12.27C246.47,254.56,242,239.3,242,239.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.45 241.34 221.66 231.63 221.66 232.56 238.45 242.37 238.45 241.34",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,239.3c-1.38,4.5-5.53,17.25-3.54,18.4s8.14-2.81,8-5.2C246.11,245.77,242,239.3,242,239.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.07,162.62a4.16,4.16,0,0,1,4.23,2.49c3.43,6.52,1.07,73.84,1.07,73.84l-2.32-1.33s.81-21.7.73-41.46c-.06-14.51-.6-28.21-1.22-29.7a4,4,0,0,0-4.22-2.67A2.47,2.47,0,0,1,236.07,162.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.73,205c6.56-26.82,11.65-38.33,18.83-41a3.86,3.86,0,0,1,5.21,3A22.82,22.82,0,0,1,235,182.38s-9.57,20.2-11.1,27.38c-1.34,6.28-2.85,14.18-2.77,19.6a4,4,0,0,0,1.06,2.63c1.76,1.9,1.76,3.43,2.9,5.53.88,1.64,1.85,2.26,1.58,2.62a2.12,2.12,0,0,1-2.88.22,11,11,0,0,1-2.17-2.09,21.51,21.51,0,0,0,1.72,5.81c2,4.43,1.49,6.69-4.49,5.11-3.75-1-6.1-4.11-6.66-13.12a68,68,0,0,1-.1-10C212.92,217.56,213.49,210.05,214.73,205Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.34,167c.6-5.86.6-8.34.42-9.07-.82-3.33-3.14-6-5.58-10C201,141,194.68,130.18,191.77,126c-2.3-3.28-4.78-5.2-8.57-5-2.64.15-.59,10.6,2,18.13l13.95,19.25a3.15,3.15,0,0,1,.59,2.18l-1.36,13.72,4.45,5.95S209.57,174.47,210.34,167Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.42,166.16c-.2-1-.9-1.89-2.73-1.82s-3.26,2.43-3.26,2.43l5.16,2.29c.27-.68.53-1.38.75-2.08h0C210.37,166.7,210.4,166.43,210.42,166.16Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.67,120.9s5.73-.72,8.91,2.74,4.73,6.35,7.81,11.46c3.71,6.16,5.32,9.32,5.32,9.32s-5.8,7.75-14.35,6.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 183.2,
    cy: 94.01,
    r: 11.85,
    transform: "translate(-12.82 157.08) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.83,
    y: 294.48,
    width: 8.35,
    height: 14.29,
    transform: "translate(318.01 603.25) rotate(180)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.77 298.77 192.11 299.06 192.53 283.94 184.19 283.66 183.77 298.77",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.38,181.23c0,8-1,56.27-1,56.27-.2,2.29-2.34,6.52-1.88,15.33.63,12,1.67,43.06,1.67,43.06s3.91,3.88,9.43,0c0,0,7.56-43,9.06-54.88,1.3-10.35,3.52-38.46,3.52-38.46l4.62,39s-1.36,7.78-1.66,13.27,4.53,33.35,4.53,33.35a9.13,9.13,0,0,0,9.08.35s3.6-42.49,4.46-47.45-2.77-59.86-2.77-59.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,123.58a9.13,9.13,0,0,0-7.33,7,29.13,29.13,0,0,0-.69,6.34v44.3c5.85,6.37,26.25,9.34,39,0,0,0-.25-39.13-1.2-45.56-1.67-11.17-7-15.15-12.38-14.74l-12.89,1.85Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.72,102.43s1.92,9,2.69,10.51a4.08,4.08,0,0,0,2.36,1.9l-.13-6.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,89.51a4.46,4.46,0,0,0-3.68,1.3c-1.58,1.61-.69,6.67,1.27,11.62l3.62.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42,102.85c-.72.44-1.75-1-2.65-1.89s-3.81-2.22-5.27.85,1.29,7.26,3.58,8c4,1.25,4.56-1.3,4.56-1.3l.3,14.29a12.76,12.76,0,0,0,9.62,7.3c7,.95,5.58-4.84,3.27-7.68v-4.34a25.12,25.12,0,0,0,5.34.27c2.91-.45,4.74-2.75,5.63-5.9,1.42-5.07,2-9.16.75-19.12-1.32-10.91-14-11-20.87-6.71S167.42,102.85,167.42,102.85Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.42,104.07c-.36,0-1.75-2.29-2.65-3.11-1.25-1.14.36-11.45.36-11.45a4.88,4.88,0,0,1,1.21-5.21c1.71-1.89,4.58-2.1,9.47-2.86,2.56-.41,6.45-1.12,9-1.6,3.06-.57,5.59-1.17,7.75.71a5.41,5.41,0,0,1,1.5,6.07,4.93,4.93,0,0,1-.87,1.3,5,5,0,0,1-2.2,1.51s-1.33,1.19-6,1.75a68.74,68.74,0,0,1-12.86-.24c-1.34-.18-1.63,1.12-2.35,4.68C169.18,98.75,168.65,104.05,167.42,104.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.14,90.31,160.76,88a2.4,2.4,0,0,1,3.31-1.1A2.61,2.61,0,0,1,165.14,90.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82,118.06s-6.5-1.31-8.78-2.52a7.5,7.5,0,0,1-3.14-3.11,10.31,10.31,0,0,0,1.79,3.67c1.66,2.12,10.13,3.69,10.13,3.69Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.26,101.23a1.31,1.31,0,1,1-2.61,0,1.32,1.32,0,0,1,1.3-1.35A1.34,1.34,0,0,1,179.26,101.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.87,96.31l-2.78,1.54a1.66,1.66,0,0,1,.65-2.22A1.54,1.54,0,0,1,177.87,96.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.23,110.23l3,1.11a1.55,1.55,0,0,1-2,1A1.66,1.66,0,0,1,180.23,110.23Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.88,97.39l-2.55-2a1.54,1.54,0,0,1,2.21-.33A1.69,1.69,0,0,1,190.88,97.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.09,100.86a1.3,1.3,0,1,1-1.3-1.36A1.33,1.33,0,0,1,190.09,100.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.45 99.62 183.88 107.46 187.97 106.06 183.45 99.62",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.18,304.65v-1.19c.8.35,2.65,7.42,6,10.44,2.64,2.4,6.23,5.18,7.14,7.85s-5,4.33-7.46,3.89c-2.86-.51-7.81-2.52-9-4.38s-1.83-4.62-2.84-6-3.34-2.89-3.89-4.47c-.3-.87.06-2.77.48-4.38s.81-3.1,1.31-3v.91a6.66,6.66,0,0,0,4.17,1.41C160.23,305.82,163.19,305.58,163.18,304.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.2,296.49c.43,0,.78.62,1.74,1.66a18,18,0,0,0,4.91,3.53c3.12,1.57,9.2,4,12,5.21,1.72.77,1.63,2.85-.14,4s-6.06,2-11.21.88c-2.81-.63-6.46-3.22-8.77-3.08s-6.63.11-8.34-1.07-1-3.68-.54-5.84c.53-2.35,1.28-6,2.06-5.8l0,.75c1,1.51,6.11,2.13,8.31,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.15,202.55a30.94,30.94,0,0,0,11.62-6.66s-2.25,4.2-8.91,8.1l1.91,37.58Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M142.46,193.78a92.15,92.15,0,0,0,1.5,11.28c2.5,9.64,5.7,12.53,10,12.81,6.81.46,6.85-2.09,3.8-6.48a21.67,21.67,0,0,1-3-6.27,15.93,15.93,0,0,0,3.27,2.11,2.35,2.35,0,0,0,3.07-.83c.22-.46-1-.92-2.27-2.51-1.66-2-2.51-3.65-4.81-5.34a4.73,4.73,0,0,1-1.38-2.81c-.34-1.37-.58-23.23.66-27.75l5.85-21c4.77-3.27,9.84-19.45,2.6-22.89-6.8.77-11.76,9.66-19.17,37.12C141.2,166.05,141.69,186.3,142.46,193.78Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.18,123.67a8.75,8.75,0,0,1,2.94,6.6c.19,4.58-2,11.18-3.25,15.31s-4,11.6-4,11.6-11.19-1.28-13.74-7.85c0,0,5.25-17,10.29-22.48A9.46,9.46,0,0,1,163.18,123.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,159.79l-.89-.76h0a1,1,0,0,0-.91-.1l-9.56,2.6a3.51,3.51,0,0,0-2.15,2l-6.89,19.86a.9.9,0,0,0,.13,1h0l.91.79,0-.66h.07l9.57-2.6a3.51,3.51,0,0,0,2.15-2c1.35-3.91,5.53-16,6.89-19.87a1.55,1.55,0,0,0,.07-.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.45,184.18l6.88-19.87a3.53,3.53,0,0,1,2.15-2l9.57-2.6c.89-.24,1.36.27,1.06,1.13-1.35,3.91-5.53,16-6.88,19.87a3.56,3.56,0,0,1-2.15,2l-9.57,2.6C189.62,185.55,189.15,185,189.45,184.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.31,168.84c-.67,2-3.08,3.37-7,4.31s-6.14,5.13-5.5,6.41,7,2.46,9.57,2.1,5.13-4.06,5.9-5.2,1.68-9.13.86-10.22a3.15,3.15,0,0,0-2.55-.93Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.93,140l-24.59-14.06s-12,16.45-3.82,21.1,16.24,9.37,24.35,14.06C138.07,157.49,132.93,140,132.93,140Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.93,140l-24.59-14.06s-12,16.45-3.82,21.1,16.24,9.37,24.35,14.06C138.07,157.49,132.93,140,132.93,140Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128.87 142.34 112.64 132.96 112.64 134.03 128.87 143.51 128.87 142.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.93,140c-1.58,5.17-6.34,19.78-4.06,21.1s9.34-3.22,9.2-6C137.66,147.41,132.93,140,132.93,140Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.68,34.63h3.17a17.8,17.8,0,0,1,17.8,17.8V90.25a0,0,0,0,1,0,0H78.88a0,0,0,0,1,0,0V52.43A17.8,17.8,0,0,1,96.68,34.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.17,121.11c2.32-2.16,1.37-4.68-1.85-11.59s-10.88-22.89-12.8-26.32c-3.35-6-7.28-6.3-13.19-6.28-2.38,0,3.65,6.82,6.37,13.43,2.45,6,12,25.55,12,25.55Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,276c-.85-.76-1.71-1.51-2.49-2.22-2.42-2.2-4.26-5.94-5.32-8.49a12,12,0,0,1-.91-4.59v-5H78v8.08h0V264l.05,0c.42,1.81,4.42,6.63,6.69,9.77,1.52,2.11,4.42,4.79,7.88,5.25C95.85,279.47,97.53,278.43,95.4,276Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.59,262.69a2.07,2.07,0,0,0,.62-.56c.68-.93.14-1.44-.35-2.18a19.25,19.25,0,0,1-1.5-3.26c-.4-1-.93-2.76-.93-2.76s0-1.31,0-1.83v-5h-8.72v8.31l0,0c.45,1.93,2.21,3.81,3.37,5.35.89,1.19,3.2,1.8,4.59,2.1a5.18,5.18,0,0,0,1.88.12A2.66,2.66,0,0,0,120.59,262.69Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7,128.6c-6.76,14.76.24,66.76.24,66.76-.2,2.39-2.94,7.11-4,17.65-1.21,12.46,1.89,43.73,1.89,43.73a9.43,9.43,0,0,0,8.81.35S95,210,96.55,197.6c1.36-10.81,4-34.57,4-34.57l5.2,34.56a63.67,63.67,0,0,0-2.35,10.66c-.71,7.29,6.35,41.21,6.35,41.21s3,1.1,8.72.26c0,0,2.49-45,3.15-53.79,1.11-14.74-.57-60.76-3.28-69.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.53,163l2.19-13.71s9.29-1.92,13.5-5.88c0,0-4.42,5.49-11,7.29l-2.46,10.56,2.2,31.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7,262.46V261.2c.84.36,2.79,7.79,6.26,10.95,2.76,2.51,6.52,5.42,7.47,8.22s-5.23,4.52-7.81,4.07c-3-.53-8.18-2.64-9.48-4.59s-1.91-4.84-3-6.27-3.49-3-4.07-4.68c-.31-.91.06-2.91.5-4.59s.85-3.25,1.38-3.1v1a6.93,6.93,0,0,0,4.36,1.48C83.61,263.69,86.71,263.43,86.7,262.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.43,253.93c.45,0,.94.7,1.94,1.78a19.18,19.18,0,0,0,5.14,3.7c3.27,1.64,9.63,4.16,12.51,5.46,1.8.81,1.72,3-.14,4.21s-6.35,2.13-11.74.93c-2.94-.66-6.76-3.37-9.18-3.23s-6.94.12-8.73-1.12-1.07-3.86-.57-6.11c.55-2.47,1.24-6.31,2.06-6.15v.85c1,1.59,6.47,2.24,8.78,1.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.62,77.32h0c-8.67.6-9.27,4.78-11.44,9.36-1.65,3.48-1.11,7.64.15,11.28l5.48,17.35S83,122.15,79.7,128.6c15.15,8.46,34.07,4,38.62-2.16.2-1.31-1-11.54-1.7-18.22,2.67-6.7,3.38-10.94,2.25-15.37-2.09-8.21-10.2-16.21-13.79-15.92Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.94,42.63l2.62,4.22a2.42,2.42,0,0,1-3.42-.7A2.62,2.62,0,0,1,77.94,42.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.29,42.47c2,1.21,4.58,6.36,4.33,17.16C115.4,68.78,112.44,71,111,71.7s-4.36.25-7.16-.21V77s3.86,4.48,3.62,7-5.57,3.11-9.19.65a23.33,23.33,0,0,1-5.92-6.2V65.15s-1.89,2.52-5,.47-3.2-7.12-1.41-8.94S91.58,55.44,92.3,58c0,0,4.45.17,10.38-3.09A16.7,16.7,0,0,0,111.29,42.47Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.37,57.33a1.16,1.16,0,0,1-1.09,1.25,1.2,1.2,0,0,1-.12-2.39A1.17,1.17,0,0,1,104.37,57.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7,65.09l2.68.85a1.37,1.37,0,0,1-1.74,1A1.47,1.47,0,0,1,105.7,65.09Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.81,53.8l-2.33-1.62a1.36,1.36,0,0,1,1.93-.39A1.48,1.48,0,0,1,113.81,53.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.27,56.5a1.16,1.16,0,0,1-1.09,1.25,1.2,1.2,0,0,1-.12-2.39A1.17,1.17,0,0,1,113.27,56.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.65 55.84 107.83 62.77 111.48 61.64 107.65 55.84",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.79,71.49c-2.94-.39-9-2.13-9.94-4.52A6.16,6.16,0,0,0,96,70c1.81,1.55,7.82,3.3,7.82,3.3Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.49,130.24c-4.12-1-8.31-5.49-6.42-9.89a6.16,6.16,0,0,1,2.64-2.93,2.36,2.36,0,0,1,2.75.29c-2-1.3-5.39-7.63-5.85-9.94L86.27,100a12.85,12.85,0,0,1,.46-5.31l-6.09-7-1.12.78c-1,3-.25,6.5.81,9.55l5.48,17.35S83,122.15,79.7,128.6a39.17,39.17,0,0,0,32.37,2.15A44.22,44.22,0,0,1,95.49,130.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9,118.81C72.46,92,77.16,82.52,82.35,79.39a12.56,12.56,0,0,1,6.36-1.68,5.76,5.76,0,0,1,1.23,3.11A22.83,22.83,0,0,1,86.2,96.18s-9.57,20.2-11.1,27.38c-1.34,6.28-2.85,14.18-2.77,19.6a4,4,0,0,0,1.06,2.63c1.76,1.9,1.76,3.43,2.9,5.53.88,1.64,1.85,2.25,1.58,2.62a2.11,2.11,0,0,1-2.88.21,10.62,10.62,0,0,1-2.17-2.08,21.51,21.51,0,0,0,1.72,5.81c2,4.43,1.49,6.69-4.49,5.11-3.75-1-6.1-4.11-6.66-13.12a68,68,0,0,1-.1-10C64.09,131.36,64.66,123.85,65.9,118.81Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.2,116.66c1.8.52,3.55.29,6,1.22a19.6,19.6,0,0,0,5.78,1.47c2.16.18,4.28-2.1,9.81-5.24,5.25-3,11.72,3.18,8.36,7a13.09,13.09,0,0,1-4.09,2.67c-2.51,1-5,1.53-11.43,3.48a20.87,20.87,0,0,0-3.14,1.37,28.74,28.74,0,0,1-3.85,1.42,18.4,18.4,0,0,1-9.31.57A9.14,9.14,0,0,1,96.28,128c-1.15-1.3-2.19-3.77-1.8-5.51a2.36,2.36,0,0,1,.79-1.35c1-.79,2.55-.29,3.68-.11a20.29,20.29,0,0,0,4,.42c2.16-.09,3.67-.45,3.37-.77s-1.56-.17-3.27-1-2.77-2.47-2.28-3.35S101.4,116.14,103.2,116.66Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.14,115s2.94-.49,4.85,2.85,2.91,21,2.91,21l-2-1.17s-.68-14.13-2.38-18.16a5.25,5.25,0,0,0-5.33-3.16A2.86,2.86,0,0,1,123.14,115Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barrier--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.38,162.36H46.64v136.3h0a2.18,2.18,0,0,0,1.28,1.78,6.8,6.8,0,0,0,6.18,0,2.18,2.18,0,0,0,1.28-1.78h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.01,
    cy: 162.36,
    rx: 4.37,
    ry: 2.52,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,179.21c31.05,29.46,68.61,50.51,111.64,64.46V235c-43-14-80.59-35-111.64-64.45Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.64,179.21c31.05,29.46,68.61,50.51,111.64,64.46V235c-43-14-80.59-35-111.64-64.45Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.17,227.25h-8.73V363.54h0a2.16,2.16,0,0,0,1.28,1.79,6.84,6.84,0,0,0,6.17,0,2.16,2.16,0,0,0,1.28-1.79h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.72,229a6.84,6.84,0,0,0,6.17,0c1.71-1,1.71-2.58,0-3.57a6.84,6.84,0,0,0-6.17,0C158,226.45,158,228,159.72,229Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.91,243.29c31.05,29.46,68.61,50.51,111.64,64.46V299.1c-43-14-80.59-35-111.64-64.46Z",
    style: {
      fill: "#E34B4B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.91,243.29c31.05,29.46,68.61,50.51,111.64,64.46V299.1c-43-14-80.59-35-111.64-64.46Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,292.13h-8.74v136.3h0a2.17,2.17,0,0,0,1.28,1.79,6.86,6.86,0,0,0,6.18,0,2.19,2.19,0,0,0,1.28-1.79h0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.6,
    cy: 292.13,
    rx: 4.37,
    ry: 2.52,
    style: {
      fill: "#455a64"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/queue.71ce9e2e0fa5e6f4a76198c48e5b6b2e.svg";
export { ForwardRef as ReactComponent };